"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MemberTable = void 0;
var _core = require("@material-ui/core");
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableContainer = _interopRequireDefault(require("@material-ui/core/TableContainer"));
var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _styles = require("@material-ui/styles");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _MoreHoriz = _interopRequireDefault(require("@material-ui/icons/MoreHoriz"));
var _pittaModules = require("@thingsw/pitta-modules");
var _Fonts = require("../constants/Fonts");
var _IconButton = require("./IconButton");
var _CheckBox = require("./CheckBox");
var _Avatar = require("./Avatar");
var _Typography = require("./Typography");
var _FiberManualRecord = _interopRequireDefault(require("@material-ui/icons/FiberManualRecord"));
var _CameraInfo = require("./CameraInfo");
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _moment = _interopRequireDefault(require("moment"));
var _clsx2 = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var statusColors = {
  P: _pittaModules.LightColors.secondary["17"],
  A: _pittaModules.LightColors.secondary["15"],
  E: _pittaModules.LightColors.secondary["11"]
};
var MEMBER_HEADERS = ["Name", "Role", "Group", "Camera", "Date invited", "Status"];
var TableHeaderCell = (0, _styles.withStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: _objectSpread({
      border: "none",
      borderTop: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
    }, theme.direction === "rtl" ? {
      textAlign: "right"
    } : {
      textAlign: "left"
    }),
    //@ts-ignore
    head: _objectSpread({
      padding: theme.spacing(1, 1, 1.375),
      color: _pittaModules.LightColors.primary["2"]
    }, _Fonts.Fonts.Default.Small)
  });
})(_TableCell.default);
var TableCell = (0, _styles.withStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: _objectSpread({
      border: "none",
      boxShadow: "0px -1px 0px ".concat(_pittaModules.LightColors.primary["6"])
    }, theme.direction === "rtl" ? {
      textAlign: "right"
    } : {
      textAlign: "left"
    }),
    head: {
      padding: 5,
      borderTop: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
    },
    //@ts-ignore
    body: _objectSpread({
      padding: "12px 8px 13px",
      "&:first-child": {
        padding: "9px 5px 27px 5px"
      },
      color: _pittaModules.LightColors.primary["1"],
      verticalAlign: "top"
    }, _Fonts.Fonts.Default.Body)
  });
})(_TableCell.default);
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    membersTablewrap: {
      "&::-webkit-scrollbar": {
        display: "none"
      },
      overflowX: "unset"
    },
    deleteDiv: {
      padding: 5
    },
    moreDiv: {
      width: 24
    },
    moreBtn: {
      padding: 0
    },
    rowHover: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "".concat(_pittaModules.LightColors.primary["6"], "!important")
      }
    },
    rowSelected: {
      backgroundColor: "".concat(_pittaModules.LightColors.primary["10"], "!important")
    },
    avatarDiv: _objectSpread({}, theme.direction === "rtl" ? {
      marginLeft: theme.spacing(2)
    } : {
      marginRight: theme.spacing(2)
    }),
    row: {
      display: "flex",
      alignItems: "center",
      "&:first-child": {
        marginBottom: 2
      }
    },
    infoDiv: {
      display: "flex",
      alignItems: "center"
    },
    deleteBtnDiv: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      width: "fit-content"
    },
    disableDeleteBtnDiv: {
      cursor: "auto",
      opacity: 0.35
    },
    statusDiv: {
      display: "flex",
      alignItems: "center"
    },
    tdCheckBox: {
      minWidth: 30,
      width: 40
    },
    tdName: {
      minWidth: 233,
      width: 249
    },
    tdRole: {
      minWidth: 128,
      width: 144
    },
    tdGroup: {
      minWidth: 172.67,
      width: 189
    },
    tdCamera: {
      minWidth: 172.67,
      width: 189
    },
    tdInvited: {
      minWidth: 172.67,
      width: 189
    },
    tdStatus: {
      minWidth: 86,
      width: 104
    },
    dateTimeText: {
      whiteSpace: "nowrap"
    },
    mailStatusIcon: _objectSpread({}, theme.direction === "rtl" ? {
      marginRight: 5.5
    } : {
      marginLeft: 5.5
    }),
    borderNone: {
      "&:nth-child(2)": {
        width: 250
      },
      border: "none",
      boxShadow: "none"
    },
    emailDiv: {
      maxWidth: 350
    },
    emailText: {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    }
  };
});
var MemberTable = function MemberTable(props) {
  var _onClick = props.onClick,
    onDeleteAll = props.onDeleteAll,
    onClickMore = props.onClickMore,
    members = props.members,
    groupList = props.groupList,
    cameras = props.cameras,
    t = props.t,
    disableDelete = props.disableDelete,
    filterNodata = props.filterNodata,
    currentLoginEmail = props.currentLoginEmail;
  var classes = useStyles(props);
  var buttonsRef = (0, _react.useRef)(_lodash.default.map(members, function () {
    return /*#__PURE__*/(0, _react.createRef)();
  }));
  var _React$useState = _react.default.useState("none"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    allChecked = _React$useState2[0],
    setAllChecked = _React$useState2[1];
  var _React$useState3 = _react.default.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    selected = _React$useState4[0],
    setSelected = _React$useState4[1];
  var newSelecteds = _lodash.default.map(members, function (n) {
    return n.email;
  });
  var numSelected = selected.length;
  var rowCount = newSelecteds.length;
  (0, _react.useEffect)(function () {
    if (numSelected === 0) {
      setAllChecked("none");
    } else if (numSelected < rowCount) {
      setAllChecked("intermediate");
    } else if (numSelected === rowCount) {
      setAllChecked("all");
    }
  }, [rowCount, numSelected]);
  var getDateTime = (0, _react.useCallback)(function (dateInvited) {
    return (0, _moment.default)(dateInvited).format("MMM D, YYYY h:mm A");
  }, []);
  var isSelected = (0, _react.useCallback)(function (email) {
    return selected.indexOf(email) !== -1;
  }, [selected]);
  var handleSelectAllClick = (0, _react.useCallback)(function (e) {
    if (allChecked === "intermediate" || allChecked === "all") {
      setSelected([]);
    } else {
      setSelected(_lodash.default.map(members, function (n) {
        return n.email;
      }));
    }
  }, [allChecked, members]);
  var handleClick = (0, _react.useCallback)(function (e, email) {
    var selectedIndex = selected.indexOf(email);
    if (selectedIndex > -1) {
      setSelected(_lodash.default.filter(selected, function (e) {
        return e !== email;
      }));
    } else {
      setSelected([].concat(_toConsumableArray(selected), [email]));
    }
  }, [selected]);
  var renderTable = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement(_TableContainer.default, {
      className: classes.membersTablewrap
    }, /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-label": "simple table"
    }, /*#__PURE__*/_react.default.createElement(_TableHead.default, {
      style: {
        boxShadow: filterNodata ? "none" : "0px -1px 0px ".concat(_pittaModules.LightColors.primary["6"])
      }
    }, /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      style: {
        boxShadow: filterNodata ? "none" : "0px -1px 0px ".concat(_pittaModules.LightColors.primary["6"])
      }
    }, /*#__PURE__*/_react.default.createElement(TableCell, {
      className: (0, _clsx2.default)(filterNodata && classes.borderNone),
      style: {
        width: filterNodata ? 32 : ""
      }
    }, /*#__PURE__*/_react.default.createElement(_CheckBox.CheckBox, {
      color: "primary",
      indeterminate: allChecked === "intermediate",
      checked: allChecked === "all",
      onChange: handleSelectAllClick
    })), numSelected > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TableHeaderCell, {
      className: classes.deleteDiv
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx2.default)(classes.deleteBtnDiv, _defineProperty({}, classes.disableDeleteBtnDiv, disableDelete)),
      onClick: disableDelete ? undefined : function () {
        selected && (onDeleteAll === null || onDeleteAll === void 0 ? void 0 : onDeleteAll(selected));
      }
    }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
      style: {
        padding: 3,
        fontSize: 24
      },
      htmlColor: _pittaModules.LightColors.secondary["11"]
    }), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
      category: "Default",
      variant: "Body",
      htmlColor: _pittaModules.LightColors.secondary["11"],
      style: {
        marginLeft: 1
      }
    }, t("Delete All"), "/", numSelected))), /*#__PURE__*/_react.default.createElement(TableHeaderCell, null), /*#__PURE__*/_react.default.createElement(TableHeaderCell, null), /*#__PURE__*/_react.default.createElement(TableHeaderCell, null), /*#__PURE__*/_react.default.createElement(TableHeaderCell, null), /*#__PURE__*/_react.default.createElement(TableHeaderCell, null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _lodash.default.map(MEMBER_HEADERS, function (header) {
      return /*#__PURE__*/_react.default.createElement(TableHeaderCell, {
        key: "table-header-".concat(header),
        className: (0, _clsx2.default)(filterNodata && classes.borderNone)
      }, t(header));
    })), /*#__PURE__*/_react.default.createElement(TableHeaderCell, {
      className: classes.moreDiv
    }))), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, _lodash.default.map(members, function (member, index) {
      var _$find;
      var isItemSelected = isSelected(member.email);
      var foundGroup = _lodash.default.find(groupList, function (o) {
        return o.GroupName === member.groupName;
      });
      var camPSN = _lodash.default.compact(_lodash.default.map(foundGroup === null || foundGroup === void 0 ? void 0 : foundGroup.DashCamUser, function (n) {
        if (_lodash.default.find(n.Users, function (u) {
          return u.Email === member.email;
        })) {
          return n.PSN;
        }
      }))[0];
      var foundUserCam = (_$find = _lodash.default.find(cameras === null || cameras === void 0 ? void 0 : cameras.deviceListInfo, function (dev) {
        return dev.device.psn === camPSN;
      })) === null || _$find === void 0 ? void 0 : _$find.device;
      return /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        key: index,
        role: "checkbox",
        "aria-checked": isItemSelected,
        classes: {
          hover: classes.rowHover,
          selected: classes.rowSelected
        },
        selected: isItemSelected,
        onClick: function onClick() {
          _onClick === null || _onClick === void 0 ? void 0 : _onClick(member.email);
        }
      }, /*#__PURE__*/_react.default.createElement(TableCell, {
        component: "th",
        scope: "row",
        className: classes.tdCheckBox
      }, /*#__PURE__*/_react.default.createElement(_CheckBox.CheckBox, {
        color: "primary",
        key: member.email,
        checked: isItemSelected,
        onClick: function onClick(e) {
          e.stopPropagation();
          handleClick(e, member.email);
        }
      })), /*#__PURE__*/_react.default.createElement(TableCell, {
        className: classes.tdName
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.infoDiv
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.avatarDiv
      }, /*#__PURE__*/_react.default.createElement(_Avatar.Avatars, {
        name: member.lastName,
        imgSrc: member.profileImg
      })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.row
      }, member.firstName && member.lastName ? /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Body",
        htmlColor: _pittaModules.LightColors.primary["1"]
      }, "".concat(member.firstName, " ").concat(member.lastName)) : "–"), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _clsx2.default)(classes.row, classes.emailDiv)
      }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Caption",
        htmlColor: _pittaModules.LightColors.primary["2"],
        className: classes.emailText
      }, member.email)))))), /*#__PURE__*/_react.default.createElement(TableCell, {
        className: classes.tdRole
      }, t(_pittaModules.RoleNames[member.role])), /*#__PURE__*/_react.default.createElement(TableCell, {
        className: classes.tdGroup
      }, member.groupName ? /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Body"
      }, member.groupName) : "–"), /*#__PURE__*/_react.default.createElement(TableCell, {
        className: classes.tdCamera
      }, member.role === "User" && foundUserCam ? /*#__PURE__*/_react.default.createElement(_CameraInfo.CameraInfo, {
        camera: foundUserCam,
        hideIcon: true
      }) : "–"), /*#__PURE__*/_react.default.createElement(TableCell, {
        className: classes.tdInvited
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.row
      }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Body",
        htmlColor: _pittaModules.LightColors.primary["1"],
        className: classes.dateTimeText
      }, getDateTime(member.dateInvited))), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.row
      }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Caption",
        htmlColor: _pittaModules.LightColors.primary["2"]
      }, "by", " ", currentLoginEmail === member.hostEmail ? "".concat(t("You"), " \xB7 ").concat(t(_pittaModules.UserNames[member.hostRole])) : "".concat(member.hostfirstName, " ").concat(member.hostlastName, " \xB7 ").concat(t(_pittaModules.UserNames[member.hostRole])))))), /*#__PURE__*/_react.default.createElement(TableCell, {
        className: classes.tdStatus
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.statusDiv
      }, /*#__PURE__*/_react.default.createElement(_FiberManualRecord.default, {
        style: {
          color: "".concat(statusColors[member.mailStatus]),
          fontSize: 15
        }
      }), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Body",
        htmlColor: statusColors[member.mailStatus],
        className: classes.mailStatusIcon
      }, t(_pittaModules.StatusNames[member.mailStatus])))), /*#__PURE__*/_react.default.createElement(TableCell, {
        className: classes.moreDiv
      }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
        ref: buttonsRef.current[index],
        className: classes.moreBtn,
        color: "secondary",
        onClick: function onClick(e) {
          e.stopPropagation();
          onClickMore(member.email, buttonsRef.current[index]);
        }
      }, /*#__PURE__*/_react.default.createElement(_MoreHoriz.default, null))));
    }))));
  }, [classes.membersTablewrap, classes.borderNone, classes.deleteDiv, classes.deleteBtnDiv, classes.disableDeleteBtnDiv, classes.moreDiv, classes.rowHover, classes.rowSelected, classes.tdCheckBox, classes.tdName, classes.infoDiv, classes.avatarDiv, classes.row, classes.emailDiv, classes.emailText, classes.tdRole, classes.tdGroup, classes.tdCamera, classes.tdInvited, classes.dateTimeText, classes.tdStatus, classes.statusDiv, classes.mailStatusIcon, classes.moreBtn, filterNodata, allChecked, handleSelectAllClick, numSelected, disableDelete, t, members, selected, onDeleteAll, isSelected, groupList, cameras === null || cameras === void 0 ? void 0 : cameras.deviceListInfo, getDateTime, currentLoginEmail, _onClick, handleClick, onClickMore]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderTable());
};
exports.MemberTable = MemberTable;